import { ChevronDownIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"
import React, { useState } from "react"

import { formatTagLabel } from "./blogTagUtils"

const pillBase =
  "shrink-0 rounded-full border px-4 py-2 text-sm font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"

const BlogTagFilter = ({ tags, activeTag, onSelectTag, accentColor, textDark }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!tags.length) return null

  const handleSelect = (value) => {
    onSelectTag(value)
  }

  const renderPill = (label, value, isActive) => (
    <button
      key={value ?? "all"}
      type="button"
      className={`${pillBase} ${isActive ? "shadow-md" : "hover:-translate-y-px hover:shadow-sm"}`}
      style={
        isActive
          ? {
              borderColor: accentColor,
              backgroundColor: accentColor,
              color: "#fff",
              boxShadow: `0 4px 14px ${accentColor}33`
            }
          : {
              borderColor: "rgba(0,0,0,0.08)",
              backgroundColor: "#fff",
              color: textDark
            }
      }
      aria-pressed={isActive}
      onClick={() => handleSelect(value)}>
      {label}
    </button>
  )

  return (
    <div role="group" aria-label="Filter posts by topic">
      <div className="mb-3 flex items-center justify-between gap-3">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-gray-dark">Browse by topic</p>
        <button
          type="button"
          className="flex shrink-0 items-center gap-1 rounded-md px-1 py-0.5 text-sm font-semibold text-gray-dark transition-colors hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          style={{ color: textDark }}
          aria-expanded={isExpanded}
          aria-controls="blog-topic-filter-pills"
          onClick={() => setIsExpanded((open) => !open)}>
          <span>{isExpanded ? "Show less" : "Show all"}</span>
          <ChevronDownIcon
            className={`size-4 shrink-0 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
            aria-hidden
          />
        </button>
      </div>

      <div
        id="blog-topic-filter-pills"
        className={`flex gap-2.5 pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${
          isExpanded ? "flex-wrap" : "flex-nowrap overflow-x-auto"
        }`}>
        {renderPill("All topics", null, !activeTag)}
        {tags.map((tag) => renderPill(formatTagLabel(tag), tag, activeTag === tag))}
      </div>
    </div>
  )
}

BlogTagFilter.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTag: PropTypes.string,
  onSelectTag: PropTypes.func.isRequired,
  accentColor: PropTypes.string.isRequired,
  textDark: PropTypes.string.isRequired
}

export default BlogTagFilter
